import type { LoginResponseDto } from '@/api/generated';

import { useApiClient } from '@/api/util/useApiClient.util';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Req = {
  token: string;
};

type Response = LoginResponseDto | undefined;

type Return = {
  isPending: boolean;
  loginOtt: (req: Req) => Promise<Response>;
};

export const useLogin = (): Return => {
  const { restAuthenticationApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const { data } = await restAuthenticationApi.loginOtt(req.token);
      return data;
    },
  });

  return {
    isPending,
    loginOtt: mutateAsync,
  };
};
